var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2442_11792)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8536 0.853553C16.0488 0.658291 16.0488 0.341709 15.8536 0.146447C15.6583 -0.0488155 15.3417 -0.0488155 15.1464 0.146447L7.45282 7.84007C6.77548 7.31354 5.92436 7 5 7C2.79086 7 1 8.79086 1 11C1 13.2091 2.79086 15 5 15C7.20914 15 9 13.2091 9 11C9 10.0756 8.68646 9.22452 8.15993 8.54718L15.8536 0.853553ZM14.1464 4.14645C14.3417 3.95118 14.6583 3.95118 14.8536 4.14645L15.8536 5.14645C16.0488 5.34171 16.0488 5.65829 15.8536 5.85355L12.8536 8.85355C12.6583 9.04882 12.3417 9.04882 12.1464 8.85355L11.1464 7.85355C10.9512 7.65829 10.9512 7.34171 11.1464 7.14645C11.3417 6.95118 11.6583 6.95118 11.8536 7.14645L12.5 7.79289L14.7929 5.5L14.1464 4.85355C13.9512 4.65829 13.9512 4.34171 14.1464 4.14645ZM5 8C3.34315 8 2 9.34315 2 11C2 12.6569 3.34315 14 5 14C6.65685 14 8 12.6569 8 11C8 9.34315 6.65685 8 5 8Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2442_11792"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.cec355c32ee6e893378037799aad5ab7.svg";
export { ForwardRef as ReactComponent };